const SearchProductForm = ({ toggleFilters }) => {
  return (
    <>
      {toggleFilters && (
        <div className="bg-gray rounded mb-3 p-3">
          <div className="row">
            <div className="col-lg-3 form-group">
              <label for="searchcolumns" className="form-label fw-bolder">
                Search By
              </label>
              <select
                name="searchcolumns"
                id="searchcolumns"
                className="form-control"
              >
                <option value="ID">Invoice#</option>
                <option value="title">Title</option>
                <option value="amount">Amount</option>
                <option value="paid_date">Date</option>
                <option value="quantity">Quantity</option>
                <option value="brand_name">Brand Name</option>
                <option value="supplier_name">Supplier Name</option>
                <option value="invoice_number">Supplier Invoice#</option>
                <option value="size">Size</option>
                <option value="quality">Quality</option>
                <option value="payment_method">Payment Method</option>
                <option value="description">Description</option>
                <option value="updated_at">Update Time</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="search_value" className="form-label fw-bolder">
                Search
              </label>
              <input
                type="text"
                className="form-control"
                name="search_value"
                id="search_value"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="orderby" className="form-label fw-bolder">
                Order By
              </label>
              <select
                name="orderby"
                id="orderby"
                className="submit_on_change form-control"
              >
                <option value="ID">Invoice#</option>
                <option value="title">Title</option>
                <option value="amount">Amount</option>
                <option value="paid_date">Date</option>
                <option value="quantity">Quantity</option>
                <option value="brand_name">Brand Name</option>
                <option value="supplier_name">Supplier Name</option>
                <option value="invoice_number">Supplier Invoice#</option>
                <option value="size">Size</option>
                <option value="quality">Quality</option>
                <option value="payment_method">Payment Method</option>
                <option value="description">Description</option>
                <option value="updated_at">Update Time</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="order" className="form-label fw-bolder">
                Order
              </label>
              <select
                name="order"
                id="order"
                className="submit_on_change form-control"
              >
                <option value="desc">Descending</option>
                <option value="asc">Ascending</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="start_date" className="form-label fw-bolder">
                Start Date
              </label>
              <input
                type="date"
                name="start_date"
                id="start_date"
                value=""
                className="bytebunch-wp-date-picker form-control hasDatepicker"
                autocomplete="off"
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="end_date" className="form-label fw-bolder">
                End Date
              </label>
              <input
                type="date"
                name="end_date"
                id="end_date"
                value=""
                className="bytebunch-wp-date-picker form-control hasDatepicker"
                autocomplete="off"
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="category" className="form-label fw-bolder">
                Category:{" "}
              </label>
              <select name="category[]" id="category" className="form-control">
                <option value="" selected>
                  -- Select --
                </option>
                <option value="12">EARTH FILLING MITI</option>
                <option value="13">CEMENT</option>
                <option value="14">CRUSH</option>
                <option value="15">SAND</option>
                <option value="16">STEEL BARS SARIA</option>
                <option value="17">SANITARY MATERIAL</option>
                <option value="18">HARDWARE MATERIAL</option>
                <option value="19">ELECTRIC MATERIAL</option>
                <option value="20">PAINT MATERIAL</option>
                <option value="21">CEILING MATERIAL</option>
                <option value="22">IRON WORK MATERIAL</option>
                <option value="23">FIBER MATERIAL</option>
                <option value="24">WOOD MATERIAL</option>
                <option value="25">LAND ZAMEEN</option>
                <option value="26">BRICKS</option>
                <option value="27">ALUMINIUM MATERIAL</option>
                <option value="28">FLOOR TILE</option>
                <option value="29">SHUTTERING MATERIAL</option>
                <option value="30">FUEL</option>
                <option value="49">WAPDA</option>
                <option value="66">OTHERS</option>
                <option value="82">STATIONERY &amp; PRINTING</option>
                <option value="83">FURNITURE &amp; FIXTURES</option>
                <option value="86">MACHINERY &amp; VEHICLES</option>
                <option value="90">TILE</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="search_only" className="form-label fw-bolder">
                Search Only
              </label>
              <select
                name="search_only"
                id="search_only"
                className="submit_on_change form-control"
              >
                <option value="available" selected="selected">
                  Available
                </option>
                <option value="all">All</option>{" "}
              </select>
            </div>
            <div className="clearboth"></div>
          </div>
          <div class="row">
            <div class="col-lg-12 bg-gray pb-3">
              <button class="btn site_btn text-white">Search</button>
              <button class="btn site_btn text-white mx-3">Reset</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchProductForm;
